import Glide from "@glidejs/glide"

class CusbarDesktopSlider {
  constructor() {
    
    if (document.querySelector(".cusdestop-slider")) {
      const dotCount = document.querySelectorAll(".cusdestop-slider__slide").length

      if(dotCount < 8) {
          new Glide('#glide2', {
            type: 'slider',
            startAt: 0,
            dragThreshold: false,
            gap: 0,
            perView: 8,
          }).mount();
        }else {
          new Glide('#glide2', {
            type: 'carousel',
            startAt: 0,
            autoplay: 3000,
            hoverpause: true,
            gap: 0,
            perView: 8,
          }).mount();
      }
      
    }


    new Glide('#glide3', {
      type: 'carousel',
      startAt: 0,
      autoplay: 3000,
      hoverpause: true,
      gap: 20,
      // animationTimingFunc: ease,
      perView: 5,
      breakpoints: {
        800: {
          perView: 5
        },
      600: {
          perView: 4
        }
      }
    }).mount();
    
    
  }
}

export default CusbarDesktopSlider
